// src-brand/main.tsx — entry RINGAN toko brand (root custom domain / subdomain).
// Tanpa admin/auth: hanya BrandStorePage. Style via styles/entry-brand.css (scoped).
import React from 'react';
import ReactDOM from 'react-dom/client';
import '../styles/entry-brand.css';
import BrandApp from './BrandApp';
import '../App/bootstrap';

declare global { interface Window { __CM_BOOT_OK?: boolean } }

const el = document.getElementById('root');
if (!el) {
  (window as any).__CM_BOOT_OK = true;
  document.body.innerHTML = '<p style="font-family:system-ui;text-align:center;padding:40px">Halaman tidak dapat dimuat.</p>';
} else {
  try {
    ReactDOM.createRoot(el).render(<BrandApp />);
    (window as any).__CM_BOOT_OK = true;
  } catch {
    (window as any).__CM_BOOT_OK = true;
    el.innerHTML = '<p style="font-family:system-ui;text-align:center;padding:40px">Halaman tidak dapat dimuat. Silakan muat ulang.</p>';
  }
}
